import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StoreService } from 'src/app/services/store.service';
import { specialsTypesEnum } from 'src/app/Interfaces/special';

@Component({
	selector: 'app-special-dialog',
	templateUrl: 'special-dialog.component.html',
	styleUrls: ['../products/products.component.scss'],
	styles: [
		`
			.main-menu__logo-col-title {
				color: black;
				font-size: 18px;
			}

			@media (min-width: 768px) {
				.main-menu__logo-col-title {
					font-size: 24px;
				}
			}
		`,
	],
})
export class SpecialInfoDialogComponent {
	constructor(public dialogRef: MatDialogRef<SpecialInfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public _ss: StoreService) {
		if (data?.special.length) {
			this.specialName = data.special[0].Name;
			this.isFatherSon = data.special[0].SpecialType === specialsTypesEnum.FATHER_SON;
			for (const special of data.special) {
				special.totalQuantity = special.TeudaQuantity + special.TeudaPackQuantity * (special.ItemPack || 1);
				special.totalPrice = special.TeudaItemNetPrice * special.totalQuantity;
				if (this.isFatherSon) {
					special.totalQuantity = special.Quantity;
					special.totalPrice = special.Price * special.Quantity;
				}
			}
			this.total = data.special.reduce((prev, curr) => prev + curr.TeudaItemNetPrice * curr.totalQuantity, 0);
			if (this.isFatherSon) {
				this.total = data.special.reduce((prev, curr) => prev + +curr.totalPrice, 0);
			}
		}
	}

	total = 0;
	specialName = '';
	isFatherSon = false;

	onNoClick(): void {
		this.dialogRef.close();
	}
}
